export default __webpack_public_path__ + "static/media/exclamation-triangle-solid.3b29a93f.svg";